export enum TramiteEnum {
    DenunciaFiscal = 4, // 4 Para db: cgr-sgdea-test//Para pruebas: 37    
    DerechoPeticion = 3, // 3 Para db: cgr-sgdea-test //Para pruebas: 46
    Denuncia = -1, //solo en ioip 26
    //TRAMITES DE CONGRESISTA
    SolicitudInformacion = 51,
    SolicitudDocumentos = 52,
    InvitacionDebatePolitico = 53,
    IntervencionExcepcional = 54
}